var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOptionsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 24,
    viewBox: "0 0 6 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14224",
    "data-name": "Group 14224",
    transform: "translate(-1483.134 -690)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_799",
    "data-name": "Ellipse 799",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(1483.134 690)",
    fill: "#9d7eb4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_800",
    "data-name": "Ellipse 800",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(1483.134 699)",
    fill: "#9d7eb4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_801",
    "data-name": "Ellipse 801",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(1483.134 708)",
    fill: "#9d7eb4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionsIcon);
export default __webpack_public_path__ + "static/media/options-icon.60d8f627779202d4aa3fae796a2ae5b5.svg";
export { ForwardRef as ReactComponent };